import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { catchError } from '../helpers/catch-error-client'
import { FaPen, FaTrash, FaCheck ,FaThumbsUp} from "react-icons/fa";


const CaseManagers = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [caseManagerEdit, setCaseManagerEdit] = useState();
  const [caseManagerAdd, setCaseManagerAdd] = useState();
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);

  const [isBtn, setIsBtn] = useState(false)
  const [inputError, setInputError] = useState(false);
  const [CaseManagers, setCaseManagers] = useState(null);
  const [editCaseManagerModalOpen, setEditCaseManagerModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => 
          <>
        <a href="javascript:void(0)" className="btn btn-sm me-1 btn-success " onClick={()=>editCaseManager(row.case_manager_id)} ><FaPen title="EDIT" /></a>
        {row.status==1?
        <a href="javascript:void(0)" className="btn btn-sm me-1 btn-danger " onClick={()=>changeStatusCaseManager(row.case_manager_id,0)} ><FaTrash title="DE-ACTIVATE" /></a>
       :
       <a href="javascript:void(0)" className="btn btn-sm me-1 btn-success " onClick={()=>changeStatusCaseManager(row.case_manager_id,1)} ><FaThumbsUp title="ACTIVATE" /></a>
        }
       </>,
        id: "action",
        cell: info => info.getValue(),
        header: () => "ACTION",
        footer: props => props.column.id,
        enableColumnFilter: false,
            enableSorting: false,
      },
      {
        accessorFn: row => row.case_manager_first_name + " "+row.case_manager_last_name,
        id: "name",
        cell: info => info.getValue(),
        header: () => "Name",
        footer: props => props.column.id
      },
      {
        accessorKey: "case_manager_email",
        header: "EMAIL",
        footer: props => props.column.id
      }, 
      {
        accessorKey: "case_manager_phone",
        header: () => "PHONE",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.can_create_wo?"Yes":"No",
        id: "canWo",
        cell: info => info.getValue(),
        header: "CREATE WO",
        footer: props => props.column.id
      }
    ],
    []
  )

  useEffect(() => {

    getCaseManagers();
    
  }, []);


  const getCaseManagers = async () => {
    setIsLoading(true);
    setCaseManagerEdit(null);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-case-managers/", {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        setCaseManagers(response?.data?.case_managers);
        setIsLoading(false);

      } else {

        Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      catchError(error,navigate)
    });

  }



  const changeStatusCaseManager = async (case_manager_id,status=1) => {

    setCaseManagerEdit(null);
    setIsLoading(true);
    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/change-status-case-manager" , 
      {
        case_manager_id:case_manager_id,
        status:status
      },
      {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {
      setIsLoading(false);
      if (response?.data?.status) {

        
        getCaseManagers();


      } else {

        Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });

      }
    }).catch(function (error) {
      setIsLoading(false);
      catchError(error,navigate)
    });

  }



  const editCaseManager = async (case_manager_id) => {

    setCaseManagerEdit(null);
    setIsLoading(true);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-case-manager-by-id/" + case_manager_id, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {
      setIsLoading(false);
      if (response?.data?.status) {

        let d = response?.data?.case_manager;
        setEditCaseManagerModalOpen(true);
        setCaseManagerEdit(d);


      } else {

        Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });

      }
    }).catch(function (error) {
      setIsLoading(false);
      catchError(error,navigate)
    });

  }



  const saveCaseManager = async (e) => {

    setIsBtn(true);
    let error_flag = false;

    const { case_manager_first_name, case_manager_last_name, case_manager_email } = caseManagerAdd;
    if (!case_manager_first_name || !case_manager_last_name || !case_manager_email || !case_manager_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {

        error_flag = true;
    }

    if (error_flag) {

        setInputError(true);
        setIsBtn(false);

    } else {

        var case_manager_info = {
          client_id: params.client_id,
            case_manager_first_name: caseManagerAdd?.case_manager_first_name,
            case_manager_last_name: caseManagerAdd?.case_manager_last_name,
            case_manager_phone: caseManagerAdd?.case_manager_phone,
            case_manager_fax: caseManagerAdd?.case_manager_fax,
            case_manager_email: caseManagerAdd?.case_manager_email,
            can_create_wo: caseManagerAdd?.can_create_wo,
            case_manager_opt_in: caseManagerAdd?.case_manager_opt_in,
          
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/add-case-manager", case_manager_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                setEditMode(false)
                setAddMode(false)
                getCaseManagers();
                setIsBtn(false)
                Swal.fire({ icon: "success", title: "Case Manager Add", text: "New case manager has been added successfully."});

            } else {
                Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });
                setIsBtn(false)
            }
        }).catch(function (error) {

          catchError(error,navigate)
        });

    }
}


const updateCaseManager = async (e) => {

    setIsBtn(true);
    let error_flag = false;

    const { case_manager_first_name, case_manager_last_name, case_manager_email } = caseManagerEdit;
    if (!case_manager_first_name || !case_manager_last_name || !case_manager_email || !case_manager_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {

        error_flag = true;
    }


    if (error_flag) {

        setInputError(true);
        setIsBtn(false);

    } else {

        var case_manager_info = {
          case_manager_id: caseManagerEdit?.case_manager_id,
          case_manager_first_name: caseManagerEdit?.case_manager_first_name,
          case_manager_last_name: caseManagerEdit?.case_manager_last_name,
          case_manager_phone: caseManagerEdit?.case_manager_phone,
          case_manager_email: caseManagerEdit?.case_manager_email,
          can_create_wo: caseManagerEdit?.can_create_wo,
          case_manager_opt_in: caseManagerEdit?.case_manager_opt_in,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/update-case-manager", case_manager_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                setEditMode(false)
                setAddMode(false)
                setEditCaseManagerModalOpen(false);
                getCaseManagers();

                setIsBtn(false)
                Swal.fire({ icon: "success", title: "Case Manager Update", text: "Case Manager has been updated successfully."});



            } else {
                Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {

          catchError(error,navigate)
            setIsBtn(false);

        });

    }


}





  const resetAddCaseManager = () => {

    setAddMode(false);
        setCaseManagerAdd(null);
  }


  const resetEditCaseManagers = () => {

    setEditMode(false);
    setEditCaseManagerModalOpen(false);
        getCaseManagers();
  }


  return (
    <>



    <div className="row pb-2 mt-4">
            <div className="col-md-7 col-sm-12 ps-3 "> 
              <h3 className="text-dark my-0">CASE MANAGERS </h3>
              </div>

            <div className="col-md-5 col-sm-12 text-md-end -2">
              { !addMode &&
                <>
                  <button onClick={() => { setAddMode(true);setCaseManagerAdd(null);  }} className="btn btn-success me-1">ADD NEW</button>
                 
                </>
              }
            </div>
            </div>

            {(addMode) &&

<div className="card card-form card-primary mb-3">
    <div className="card-heading px-3 py-3">
      <h6 className="fw-bold my-0">ADD NEW CASE MANAGER</h6>
      </div>
    <div className="card-body">
    <div className="row py-2 gx-2 form-thick">

        <div className="col-4 my-2">
            <label htmlFor="case_manager_first_name" >FIRST NAME*</label>

            <input name="case_manager_first_name" className="form-control" type="text"
                value={caseManagerAdd?.case_manager_first_name}
                onChange={(e) =>
                    setCaseManagerAdd({ ...caseManagerAdd, case_manager_first_name: e.target.value })
                }
               
            />
            {inputError && !caseManagerAdd?.case_manager_first_name &&
                <span className="text-danger">Enter first name</span>
            }




        </div>
        <div className="col-4 my-2">
            <label htmlFor="case_manager_last_name">LAST NAME*</label>

            <input name="case_manager_last_name" className="form-control"
                value={caseManagerAdd?.case_manager_last_name}
                onChange={(e) =>
                    setCaseManagerAdd({ ...caseManagerAdd, case_manager_last_name: e.target.value })
                }

            />
            {inputError &&
                !caseManagerAdd?.case_manager_last_name && (
                    <span className="text-danger">Enter valid last name</span>
                )}


        </div>

        
        <div className="col-4 my-2">


            <label htmlFor="case_manager_email" >EMAIL*</label>

            <input name="case_manager_email" id="case_manager_email" type="text" className="form-control"
                value={caseManagerAdd?.case_manager_email} onChange={(e) =>
                    setCaseManagerAdd({ ...caseManagerAdd, case_manager_email: e.target.value })
                }
            />


        </div>
     
        <div className="col-4 my-2">


            <label htmlFor="case_manager_phone" >TELEPHONE</label>

            <input name="case_manager_phone" id="case_manager_phone" type="text" className="form-control"
                value={caseManagerAdd?.case_manager_phone} onChange={(e) =>
                    setCaseManagerAdd({ ...caseManagerAdd, case_manager_phone: e.target.value })
                }
            />


        </div>
     
     
        <div className="col-4 my-2">
    <label htmlFor="case_manager_opt_in">Email Opt-In:</label>
<div className="mt-2">
    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
        onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 1 })} checked={(caseManagerAdd?.case_manager_opt_in == 1) ? "true" : ""} /> Yes
    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
        onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 0 })} checked={(caseManagerAdd?.case_manager_opt_in == 0) ? "true" : ""} /> No
</div>
</div>
<div className="col-4 my-2">
    <label htmlFor="can_create_wo">Can Create WO:</label>
    <div className="mt-2">
    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
        onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 1 })} checked={(caseManagerAdd?.can_create_wo == 1) ? "true" : ""} /> Yes
    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
        onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 0 })} checked={(caseManagerAdd?.can_create_wo == 0) ? "true" : ""} /> No
</div>
</div>
    

      
    </div>
    </div>
    <div className="card-footer">
<div className="row">
    <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
        <button onClick={() => saveCaseManager()} className="btn btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SAVE"}</button>
        <button onClick={() => { resetAddCaseManager(); }} className="btn btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                  
</div>
</div>
    </div>

</div>
}



          {isLoading ?
            
              <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
             
            :
            <>


              {CaseManagers &&
<>
  <div className="card card-form card-primary  h-100 " >
        <div className="card-body p-0 mb-5" >

         
<PrimaryTable columns={columns} data={CaseManagers} />
</div></div>
                </>
              }
            </>
          }


      






      <Modal animation={false}
        show={editCaseManagerModalOpen}
        onHide={() => { setEditCaseManagerModalOpen(false); }}
        keyboard={false}
        backdrop="static"
        id="search-case_manager-modal"
        size="lg"
      >
        <Modal.Header><h3 className="m-0 p-0">UPDATE CASE MANAGER</h3></Modal.Header>
        <Modal.Body>
          <div className="modal-inner-content form-thick">


            {isLoading ?
              <div className="text-center m-auto loader" >
                <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
              </div>
              :


              <>
                <div className="row px-3 py-1 gx-2 ">

                  <div className="col-3 my-2">
                    <label htmlFor="case_manager_first_name" >First Name*</label>

                    <input name="case_manager_first_name" className="form-control" type="text"
                      value={caseManagerEdit?.case_manager_first_name}
                      onChange={(e) =>
                        setCaseManagerEdit({ ...caseManagerEdit, case_manager_first_name: e.target.value })
                      }


                    />
                    {inputError &&
                      (!caseManagerEdit?.case_manager_first_name || !(caseManagerEdit?.case_manager_first_name?.match(/^[A-Za-z'.\-, ]+$/))) && (
                        <span className="text-danger">Enter valid first name</span>
                      )}




                  </div>
                 
                  <div className="col-3 my-2">
                    <label htmlFor="case_manager_last_name">Last Name*</label>
                    <input name="case_manager_last_name" className="form-control" type="text"
                      value={caseManagerEdit?.case_manager_last_name}
                      onChange={(e) =>
                        setCaseManagerEdit({ ...caseManagerEdit, case_manager_last_name: e.target.value })
                      }

                    />
                    {inputError &&
                      (!caseManagerEdit?.case_manager_last_name || !(caseManagerEdit?.case_manager_last_name?.match(/^[A-Za-z'.\-, ]+$/))) && (
                        <span className="text-danger">Enter valid Last name</span>
                      )}

                  </div>

                  <div className="col-3 my-2">
                    <label htmlFor="case_manager_email">EMAIL</label>

                    <input name="case_manager_email" id="case_manager_email" type="text" className="form-control"
                      value={caseManagerEdit?.case_manager_email} onChange={(e) =>
                        setCaseManagerEdit({ ...caseManagerEdit, case_manager_email: e.target.value })
                      }
                    />
                    {inputError &&
                      (caseManagerEdit?.case_manager_email && !caseManagerEdit?.case_manager_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                        <span className="text-danger">Enter a valid email</span>
                      )}


                  </div>
             
                  <div className="col-3 my-2">
                    <label htmlFor="case_manager_fax">PHONE NUMBER</label>

                    <input name="case_manager_phone" id="case_manager_phone" type="text" className="form-control"
                      value={caseManagerEdit?.case_manager_phone} onChange={(e) =>
                        setCaseManagerEdit({ ...caseManagerEdit, case_manager_phone: e.target.value })
                      }

                    />

                  </div>
                

                  <div className="col-6 my-2">
    <label htmlFor="case_manager_opt_in">Email Opt-In:</label>
<div>
    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
        onClick={() => setCaseManagerEdit({ ...caseManagerEdit, case_manager_opt_in: 1 })} checked={(caseManagerEdit?.case_manager_opt_in == 1) ? "true" : ""} /> Yes
    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
        onClick={() => setCaseManagerEdit({ ...caseManagerEdit, case_manager_opt_in: 0 })} checked={(caseManagerEdit?.case_manager_opt_in == 0) ? "true" : ""} /> No
</div>
</div>
<div className="col-6 my-2">
    <label htmlFor="can_create_wo">Can Create WO:</label>
    <div>
    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
        onClick={() => setCaseManagerEdit({ ...caseManagerEdit, can_create_wo: 1 })} checked={(caseManagerEdit?.can_create_wo == 1) ? "true" : ""} /> Yes
    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
        onClick={() => setCaseManagerEdit({ ...caseManagerEdit, can_create_wo: 0 })} checked={(caseManagerEdit?.can_create_wo == 0) ? "true" : ""} /> No
</div>
</div>
    


                </div>

              </>
            }

          </div>
        </Modal.Body>
        <Modal.Footer>

          <button type='button' onClick={() => updateCaseManager()} className="btn  btn-success" disabled={isBtn}>
            {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

            </div><span className="sr-only">Loading...</span></> : 'UPDATE CASE MANAGER'}
          </button>
          <button type='button' className="btn  btn-warning" onClick={(e) => setEditCaseManagerModalOpen(false)}  >CANCEL UPDATE</button>


        </Modal.Footer>
      </Modal>






    </>

  );
};

export default CaseManagers;